import React from 'react'

import builderStates from '../../constants/builder-states'
import BasicLgyInputField from 'app/components/util/lgy-input-field/BasicLgyInputField'
import BasicLgySelectField from 'app/components/util/lgy-select-field/BasicLgySelectField'
import BasicLgyCheckbox from 'app/components/util/lgy-checkbox/BasicLgyCheckbox'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'

const CondoForm = ({ handleSubmit, handleChange, handleInvalid, handleReset, condoReport, values, errors, stations }) =>
  <div className='condo-form usa-grid'>
    <h1>Request a Customized Condo Report</h1>
    {condoReport.list && condoReport.list.length < 1 &&
      <LgyAlertDialog type='error' heading='Not Found' text='No condos were found that match the search criteria.' />}
    <form onSubmit={handleSubmit}>
      <fieldset className='condo-name-id'>
        <legend className='instructions'>1. Retrieve only approved condos?</legend>
        <BasicLgyCheckbox label='Approved' type='checkbox' id='approved' name='approved' checked={values.approved} onChange={handleChange} autoFocus />
      </fieldset>
      <fieldset className='condo-name-id'>
        <legend className='instructions'>2. Enter the condo name (partial entry OK) and/or the full 6-digit alphanumeric ID.</legend>
        <div className='usa-width-one-half'>
          <BasicLgyInputField label='Name' type='text' id='name' name='name' maxLength='100' value={values.name} onChange={handleChange} />
        </div>
        <div className='usa-width-one-half'>
          <BasicLgyInputField className='usa-input-medium' label='ID' type='text' id='id' name='id' maxLength='6'
            pattern='[a-zA-Z0-9]{6}' value={values.id} onChange={handleChange} onInvalid={handleInvalid}
            error={errors.id ? errors.id : undefined} />
        </div>
      </fieldset>
      <fieldset className='condo-regional-offices'>
        <legend className='instructions'>3. Select the regional office with which the condo is registered.</legend>
        <BasicLgySelectField label='Regional Office' id='station' name='station' placeholder='All Offices' value={values.station} onChange={handleChange}>
          {stations && stations.map(station => <option key={station.stationNumber} value={station.stationNumber}>{station.stationCity}</option>)}
        </BasicLgySelectField>
      </fieldset>
      <fieldset className='condo-city-state-county'>
        <legend className='instructions'>4. Enter the condo's location information. State is required.</legend>
        <div className='usa-width-one-third'>
          <BasicLgyInputField label='City' type='text' id='city' name='city' maxLength='100' value={values.city} onChange={handleChange} />
        </div>
        <div className='usa-width-one-third'>
          <BasicLgySelectField label='State' id='stateCode' name='stateCode' value={values.stateCode} onChange={handleChange}
            required onInvalid={handleInvalid} error={errors.stateCode ? errors.stateCode : undefined}>
            {builderStates.map(state => <option key={state.cd} value={state.cd}>{state.label}</option>)}
          </BasicLgySelectField>
        </div>
        <div className='usa-width-one-third'>
          <BasicLgyInputField label='County' type='text' id='county' name='county' maxLength='100' value={values.county} onChange={handleChange} />
        </div>
      </fieldset>
      <LgyFormSubmit
        pristine={values.name === '' && values.id === '' && values.station === '' && values.city === '' && values.stateCode === ''
          && values.county === '' && !values.approved}
        submitting={condoReport.fetching}
        submitFailed={condoReport.error}
        invalid={errors.stateCode || errors.id}
        reset={handleReset} />
    </form>
  </div>

export default CondoForm